import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MainTracker } from "../../../PixelTrackers/MainTracker";
import * as translator from "../../../utils/translator";
import { SEARCH_PARAM_FOR_SHIPPING_METHOD_UNAVAILABLE } from "../../../utils/consts";
import * as http from "../../../utils/http";
import { isZeroOrderPrice, toChargeCurrency } from "../../../utils/helpers";
import * as SocialMediaTracker from "../../../PixelTrackers/SocialMediaTracker";
import DeliveryOptionPanel from './components/DeliveryOptionPanel';
import DeliveryAddressForm from './forms/DeliveryAddressForm';
import DeliveryAddressCard from './forms/DeliveryAddressCard';
import CustomerAddressesModal from './components/CustomerAddressesModal';
import SelfPickupPharmacySheet from './components/SelfPickupPharmacySheet';
import AddNewAddressModal, { AddressToEdit } from './components/AddNewAddressModal';
import InvalidPhonePopup, { isAddressPhoneValid } from './components/InvalidPhonePopup';
import { shouldQuoteExpressOnAddressChange } from './utils/expressAddressChange';
import StickySubmit from '../../../components/StickySubmit';
import { useShippingPageContext } from './providers/ShippingPageProvider';
import { DHL_PACKSTATION, PERSONAL_ADDRESS, EXPRESS_SHIPPING_COMPANIES, SELF_PICKUP_PAYMENT_MODELS, PRODUCT_TYPE_PRESCRIPTION_DRUG } from './constants';
import DHLPackStationForm from './forms/DHLPackStationForm';
import { useAppContext } from '../../../providers/AppProvider';
import { loadGoogleApi } from '../../Shipping/helpers';
import { useCartContext } from '../../../customHooks/useCart';
import CartViewDE from '../../../components/CartViewDE';
import CartView from '../../../components/CartView';
import OTCCartView from '../../../components/OTCCartView';
import DigitalCannabisIDWidget from '../../../components/DigitalCannabisIDWidget/DigitalCannabisIDWidget';
import PortaledModal from '../../../components/Modals/PortaledModal';
import OutOfStockModal from './components/OutOfStockModal';
import RescheduleVideoConsultationModal from '../../../components/RescheduleVideoConsultationModal';
import CouponWidgetV2 from './components/CouponWidgetV2';
import OTCAddonsModalV2 from '../../../components/Modals/OTCAddonsModal/OTCAddonsModalV2';
import OTCPopupV3 from '../../../components/Modals/OTCPopupV3/OTCPopupV3';
import TogglePrecaution from '../../Shipping/Components/TogglePrecaution';
import { ORDER_FLOWS, SHIPPING_PAGE_VIEW_EVENT, PRODUCT_TYPES, TOOLTIP_MEDICATION, TOOLTIP_SERVICE_FEE, TOOLTIP_TREATMENT_FEE, CLICK_EXPAND_PRODUCTS, CLICK_PARTNER_PHARMACIES_POPUP, CLICK_TERMS_LINK, CLICK_PHARMACY_DETAILS_EXPAND } from '../../../utils/consts';
import { shouldShowPriceBreakdown } from '../../../utils/helpers';
import UpsellUpgradeBanner from '../../../components/UpsellUpgradeBanner';
import { UpsellPopUp } from '../../Shipping/Components/UpsellPopUp/UpsellPopUp';
import * as Constants from '../../../utils/consts';
import * as SessionStorageWrapper from "../../../utils/SessionStorageWrapper";
import {CartView as CartViewType} from '../../../customHooks/useCart';
import CartViewFAQ from '../../../components/CartViewFAQ';
import CarePlusShippingCartCard from '../../CarePlusShared/CarePlusShippingCartCard';
import CarePlusCostBreakdown from '../../CarePlusShared/CarePlusCostBreakdown';
import { getCarePlusCostBreakdownRows } from '../../CarePlusShared/carePlusCostBreakdownRows';
import { getCarePlusCostBreakdownInput } from '../../CarePlusShared/carePlusCostBreakdownInput';
import { getCarePlusShippingCartProps } from '../../CarePlusShared/carePlusShippingCartProps';
import ShippingV3CarePlus from '../../v3/ShippingV3CarePlus/ShippingV3CarePlus';
import { showsCarePlusShippingFAQ } from '../../CarePlusShared/showsCarePlusShippingFAQ';
import { lineFromProducts } from '../../ChoosePlanCarePlus/useChoosePlanCarePlus';
import SaleVoucherWidget from './components/SaleVoucherWidget';
import { v4 as uuidv4 } from 'uuid';
import FastReviewUpsellPopUp from './components/FastReviewUpsellPopUp';
import { ExpressDeliveryUpsellPopup } from './components/ExpressDeliveryUpsellPopup';
import FastDoctorReview from '../../../components/FastDoctorReview/FastDoctorReview';
import UpsellPopUpV2 from '../../Shipping/Components/UpsellPopUp/UpsellPopUpV2';
import RxPremiumUpsellPopup from '../../Shipping/Components/UpsellPopUp/RxPremiumUpsellPopup';
import { ABTestManager } from '../../../utils/ABTestManager';
import { getWlExperimentTrackingProps, registerWlExperimentSuperProperties } from '../../../utils/wlCarePlusExperiment';
import { getTestLabMultiTestTrackingProps, readTestLabMultiTestVariant, registerTestLabMultiTestSuperProperty, resolveTestLabMultiTestVariant, trackTestLabMultiTestAssignment, writeTestLabMultiTestCookie } from '../../../utils/testLabMultiTestExperiment';
import { registerCustomerStatus } from '../../../utils/wlFunnelExperiment';
import { getFlowzzTrackingProps } from '../../../utils/flowzzTracking';
import { CustomerAddress } from 'data-types';
import { ABTEST_AUTO_CATALOG_COUPON_EVENT, buildAbtestAutoCatalogCouponContinueProps, buildAbtestAutoCatalogCouponProps, resolveDeliveryMethodLabel, resolveDeliveryPriceEuros } from './utils/shippingTrackingEvents';
import { ABTEST_AUTO_CATALOG_COUPON_ENDPOINT, isAbtestAutoCatalogCouponArm, isAbtestAutoCatalogCouponParticipant, resolveAutoCatalogCouponVariant, resolveAutoCatalogCouponWeight } from './utils/abtestAutoCatalogCoupon';
import { suggestableOtcAddons } from './utils/otcAddonsSuggestions';
import { assignOtcPopupVariant, trackOtcPopupDisplay, OtcPopupTrackingContext } from '../../../utils/otcPopupExperiment';
import type { OtcPopupProduct, OtcPopupVariant } from 'data-types';
import giftIcon from "../../../icons/gift_icon.svg";

const MOBILE_PHONE_WIDTH = 768;
const MAX_CART_PRODUCTS = 3;
const GIFT_ICON_SIZE_PX = 20;
const FREE_TREATMENT_BANNER_GRADIENT_START = "#15967C";
const FREE_TREATMENT_BANNER_GRADIENT_END = "#72B33E";
const FREE_TREATMENT_BANNER_BACKGROUND = `linear-gradient(90deg, ${FREE_TREATMENT_BANNER_GRADIENT_START} 0%, ${FREE_TREATMENT_BANNER_GRADIENT_END} 100%)`;
const FREE_TREATMENT_BANNER_OLD_PRICE_BADGE_BACKGROUND = "#FFFFFF40";

type ShippingPageCartTotalArgs = {
  drugsPrice: number;
  otcPrice: number;
  treatmentFee: number;
  consultationFee: number;
  serviceFee: number;
  carePlusPlanFee: number;
  shippingFee: number;
  cannabisIdPrice: number;
  bonusValue: number;
  subscriptionDiscount: number;
};

/** Payable shipping-page total from cart fee fields already loaded on this page. */
const getShippingPageCartTotal = (args: ShippingPageCartTotalArgs): number => (
  args.drugsPrice
  + args.otcPrice
  + args.treatmentFee
  + args.consultationFee
  + args.serviceFee
  + args.carePlusPlanFee
  + args.shippingFee
  + args.cannabisIdPrice
  - args.bonusValue
  - args.subscriptionDiscount
);

type SelectedShippingFeeArgs = {
  isExpressSelected: boolean;
  expressShippingFee: number;
  isOtcOnlyFlow: boolean;
  otcShippingFee: number;
  isSelfPickup: boolean;
  isOnlyPrescription: boolean;
  rxOnlyShippingFee: number;
  regularShippingFee: number;
};

/** Shipping amount for the currently selected delivery option on this page. */
const getSelectedShippingFee = (args: SelectedShippingFeeArgs): number => {
  if (args.isExpressSelected) {
    return args.expressShippingFee;
  }
  if (args.isOtcOnlyFlow) {
    return args.otcShippingFee;
  }
  if (args.isSelfPickup) {
    return 0;
  }
  if (args.isOnlyPrescription) {
    return args.rxOnlyShippingFee;
  }
  return args.regularShippingFee;
};

const MIXPANEL_IS_FREE_TREATMENT = "is_free_treatment";

/** Payable total from cartView fee fields, independent of React cart state. */
const getCartViewPayableTotal = (cartView: CartViewType): number => {
  const cannabisIdProduct = (cartView.products ?? []).find(
    (product) => product.type === PRODUCT_TYPES.CANNABIS_ID,
  );
  const shouldApplyCouponToTotal = Boolean(cartView.bonus_value)
    && !Boolean(cartView.applied_subscription_discount)
    && !(Boolean(cartView.only_prescription) && Boolean(cartView.auto_bonus));
  const shippingFee = getSelectedShippingFee({
    isExpressSelected: Boolean(
      cartView.shipping_company_code
      && EXPRESS_SHIPPING_COMPANIES.includes(cartView.shipping_company_code),
    ),
    expressShippingFee: Number(cartView.custom_shipping_fee ?? 0),
    isOtcOnlyFlow: cartView.flow === Constants.ORDER_FLOWS.OTC_ONLY,
    otcShippingFee: Number(cartView.custom_shipping_fee ?? 0),
    isSelfPickup: cartView.selected_service_option === "self_pickup",
    isOnlyPrescription: Boolean(cartView.only_prescription),
    rxOnlyShippingFee: Number(cartView.otc_price ?? 0) > 0
      ? Number(cartView.shipping_fee ?? 0)
      : 0,
    regularShippingFee: Number(cartView.shipping_fee ?? 0),
  });
  return getShippingPageCartTotal({
    drugsPrice: cartView.only_prescription ? 0 : Number(cartView.drugs_price ?? 0),
    otcPrice: Number(cartView.otc_price ?? 0),
    treatmentFee: Number(cartView.treatment_fee ?? 0),
    consultationFee: Number(cartView.consultation_fee ?? 0),
    serviceFee: Number(cartView.service_fee ?? 0),
    carePlusPlanFee: Number(cartView.care_plus_plan_fee ?? 0),
    shippingFee,
    cannabisIdPrice: Number(cannabisIdProduct?.item_price ?? 0),
    bonusValue: shouldApplyCouponToTotal ? Number(cartView.bonus_value) : 0,
    subscriptionDiscount: Number(cartView.applied_subscription_discount ?? 0),
  });
};

const normalizeZipForCompare = (zip?: string | null): string =>
  (zip ?? "").trim().toLowerCase();

const findRegularAddressByZip = (
  addresses: CustomerAddress[],
  cartZip: string,
): CustomerAddress | null => {
  const normalizedCartZip = normalizeZipForCompare(cartZip);
  if (!normalizedCartZip) return null;

  const matches = (addresses || []).filter(
    (addr) =>
      addr?.address_type !== "packstation" &&
      normalizeZipForCompare(addr?.zip) === normalizedCartZip,
  );
  if (matches.length === 0) return null;
  if (matches.length === 1) return matches[0];

  const defaultMatch = matches.find((addr) => addr.is_default);
  if (defaultMatch) return defaultMatch;
  return matches.reduce((latest, addr) => (addr.id > latest.id ? addr : latest), matches[0]);
};


const ShippingV2 = () => {
  const navigate = useNavigate();
  const uniqueSessionId = uuidv4();

  // get express delivery address from sessionStorage
  const getExpressDeliveryAddress = () => {
    try {
      const saved = sessionStorage.getItem('express_delivery_address');
      if (saved) {
        return JSON.parse(saved);
      }
    } catch (err) {
      window.clientLogger.warn('Failed to parse express delivery address from sessionStorage', err);
    }
    return null;
  };

  //App context
  const {
    setIsLoading,
    setErrorStatus,
    setStickyNotification,
    setHeaderVersion,
    setHideHeaderSteps,
    setHideHeader,
    setUseWhitePageBackground,
    setHideFooter,
  } = useAppContext();

  // Cart context
  const { saveCart, getCart, getSessionFields, updateCartAndDB, restoreCartFromOrder, cartCurrency } = useCartContext();
  const cart = getCart();
  const { handleDeliveryOptionChange, setIsCannabisCatalog, isCannabisCatalog, setIsExpressFlow, isCarePlusOrder, setIsCarePlusOrder } = useShippingPageContext();

  const [searchParams] = useSearchParams();

  // Care+ orders get a simplified cart card + stepper on this page;
  // every other DE/CH flow keeps CartViewDE/CartView/OTCCartView untouched.
  // isCarePlus comes from shipping API (catalog is_care_plus DB flag, HL-11443-B); kept on the
  // shipping context so the delivery panel can lock the Choose Plan delivery choice.
  // Prescription-only Care+ orders get no medication/shipping — only the prescription itself
  // (same cart fields as the Choose Treatment Rx-only hand-off: only_prescription/allow_only_prescription).
  const carePlusMedication = isCarePlusOrder && !cart.only_prescription ? lineFromProducts(cart.products ?? []) : null;
  // Card numbers come from the shared helper so Shipping, Register and Payment show the same totals.
  const { cardProps: carePlusCardProps } = getCarePlusShippingCartProps(cart, isCarePlusOrder);

  const [isMobile, setIsMobile] = useState<boolean>(false);
  // False until the shipping response resolves: no header is drawn meanwhile, so the page
  // doesn't flash the legacy chrome before a Care+ order switches to V3.
  const [shippingSettingsLoaded, setShippingSettingsLoaded] = useState<boolean>(false);
  const [showAddressesModal, setShowAddressesModal] = useState<boolean>(false);
  const [showAddNewAddressModal, setShowAddNewAddressModal] = useState<boolean>(false);
  const [addressToEdit, setAddressToEdit] = useState<AddressToEdit>(null);
  const [otcPopupVariant, setOtcPopupVariant] = useState<OtcPopupVariant | null>(null);
  const [OTCPopupRecommendations, setOTCPopupRecommendations] = useState<OtcPopupProduct[]>([]);
  const [otcTrackingContext, setOtcTrackingContext] = useState<OtcPopupTrackingContext>({ mixpanel_category: null, selected_product_catalog: null, selected_product_item: null });
  // Detect if mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < MOBILE_PHONE_WIDTH);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  //Shipping Context
  const {
    language,
    country,
    finishedFetching,
    setFinishedFetching,
    selectedOptionPanelCode,
    setSelectedOptionPanelCode,
    isGoogleAPILoaded,
    setIsGoogleAPILoaded,
    selectedFormID,
    setCountryCurrenciesByID,
    customerAddress,
    setCustomerAddress,
    allCustomerAddresses,
    setAllCustomerAddresses,
    invalidPhoneAddress,
    setInvalidPhoneAddress,
    preSelectedExternalPharmacy,
    setPreSelectedExternalPharmacy,
    hidePackstation,
    setHidePackstation,
    saleVoucherRequired,
    setSaleVoucherRequired,
    selfPickupPharmacySettings,
    setSelfPickupPharmacySettings,
    setContentType,
    setTestLabSampleType,
    setIsMixedOtcTestLabCart,
    isPackstationFirst,
    abtestAutoCatalogCoupon,
    setAbtestAutoCatalogCoupon,
    setUrbifyRolloutPercentage,
    setRxSelfPickup,
    setRxSelfPickupServiceOption,
    categoryCatalogMention,
    setCategoryCatalogMention,
    setAllowPrescriptionRedemption,
    isSubscriptionAlreadyPicked,
    setIsSubscriptionAlreadyPicked,
    OTCAddonsProducts,
    setOTCAddonsProducts,
    showOTCAddonsModal,
    setShowOTCAddonsModal,
    isDeepLinkCouponApplied,
    setIsDeepLinkCouponApplied,
    digitalCannabisIDState,
    setDigitalCannabisIDState,
    handleApplyCoupon,
    handleDigitalCannabisToggle,
    handleDefaultCartCurrency,
    identityCheckState,
    setIdentityCheckState,
    isSubmitButtonDisabled,
    forceFreeTreatmentFeeCoupon,
    setForceFreeTreatmentFeeCoupon,
    setExpressDeliveryState,
    expressDeliveryState,
    setShowOtcCartPopUp,
    setshowUpsellOnShippingPage,
    upsellABCtestWeights,
    setUpsellABCtestWeights,
    showRescheduleVideoConsultationModal,
    setShowRescheduleVideoConsultationModal,
    setIsOriginalCartFlowFlowzz,
    wasUpgradedToPremium,
    showUpsellPopUp,
    setShowUpsellPopUp,
    setIsFlowzzMoreExpensive,
    setUpsellSaveAmount,
    upsellSaveAmount,
    setUpsellProducts,
    finalAlternativeProducts,
    setFinalAlternativeProducts,
    eligibleForUpsell,
    setEligibleForUpsell,
    outOfStockDataState,
    setOutOfStockDataState,
    setUriForOutOfStock,
    setExpressStockCode,
    updateCartZipcode,
    otcOnlyShippingFee,
    setOtcOnlyShippingFee,
    setPharmaciesModalInfo,
    showFastReviewUpsell,
    setShowFastReviewUpsell,
    setAllPharmaciesLocations,
    isExpressPrescriptionReview,
    setIsExpressPrescriptionReview,
    isFastApprovalFlow,
    productsGroupedByPharmacy,
    setProductsGroupedByPharmacy,
    isFastReviewUpsellShown,
    setIsFastApprovalFlow,
    isFlowzzFastApprovalOffer,
    setIsFlowzzFastApprovalOffer,
    showExpressDeliveryUpsell,
    expressUpsellVariant,
    handleExpressUpsellApply,
    handleExpressUpsellContinue,
    handleExpressUpsellClose,
    contentType,
    setStandardShippingMethodID,
    setSelfPickupShippingMethodID,
    testLabSampleType,
    couponWidgetState,
    setCouponWidgetState,
    showRxPremiumUpsellPopup,
    handleRxUpsellAccept,
    handleRxUpsellDecline,
    handleRxUpsellClose,
    isPickupSheetOpen,
    setIsPickupSheetOpen,
    setSelectedPickupPharmacyCode,
    setIsReturningCustomer,
    isAlternativeOfferTreatment,
  } = useShippingPageContext();

  const carePlusT = useCallback((key: string, fallback: string) => translator.translate(language, 'choose_plan_care_plus', key) || fallback, [language]);

  const carePlusCostBreakdownRows = useMemo(() => getCarePlusCostBreakdownRows({
    t: carePlusT,
    ...getCarePlusCostBreakdownInput(cart),
  }), [cart, carePlusT]);

  // Suppress FunnelLayout's old 4-step header stepper in favor of CarePlusStepper below,
  // and use a white page background matching the Care+ Figma design instead of FunnelLayout's
  // default gray; reset both on unmount so other flows through FunnelLayout aren't affected.
  useEffect(() => {
    const settingsPending = !shippingSettingsLoaded;
    setHideHeaderSteps(isCarePlusOrder);
    setHideHeader(settingsPending || isCarePlusOrder);
    setUseWhitePageBackground(settingsPending || isCarePlusOrder);
    setHideFooter(isCarePlusOrder);
    return () => {
      setHideHeaderSteps(false);
      setHideHeader(false);
      setUseWhitePageBackground(false);
      setHideFooter(false);
    };
  }, [isCarePlusOrder, shippingSettingsLoaded]);

  // A/B Test for upsell modal (only for mobile when no alternative products)
  const upsellVariant = useMemo(() => {
    const hasNoAlternatives = Object.keys(finalAlternativeProducts || {}).length === 0;
    
    // Only run A/B test if mobile AND no alternative products
    if (!isMobile || !hasNoAlternatives) {
      return null; // Use default behavior
    }

    // Wait for API data to be available
    if (!upsellABCtestWeights) {
      return null; // Don't show anything until we have weights from API
    }

    // TODO: Remove this line after testing - it forces a new variant assignment
    // localStorage.removeItem('abtest_mobile_upsell_modal_variant');
    
    
    // Parse weights from API object format: {"A":0.5,"B":0.5}
    const weights: number[] = [
      upsellABCtestWeights.A,
      upsellABCtestWeights.B,
    ];

    const abTest = new ABTestManager({
      testName: 'mobile_upsell_modal_variant',
      variants: ['A', 'B'],
      weights: weights,
    });
    return abTest.getVariant();
  }, [isMobile, finalAlternativeProducts, upsellABCtestWeights]);



  const zipCode = (cart.zipcode ?? "").trim();
  const isExpressSelected = !!cart.shipping_company_code && EXPRESS_SHIPPING_COMPANIES.includes(cart.shipping_company_code);
  // A zip the customer checked on the CT page must survive an express → DHL switch,
  // so the address decision does not depend on the selected carrier. The session entry is
  // written by the CT zip check and cleared on a new consultation, so stale carts are unaffected.
  const hasCustomerChosenZip = zipCode.length > 0 && (isExpressSelected || !!getExpressDeliveryAddress()?.zip);
  const matchedAddressByCartZip = hasCustomerChosenZip
    ? findRegularAddressByZip(allCustomerAddresses, zipCode)
    : null;
  const useFreshAddressForm =
    hasCustomerChosenZip &&
    !matchedAddressByCartZip &&
    zipCode !== ((customerAddress["regular"]?.zip as string | undefined) ?? "").trim();
  const regularAddressForDisplay = useFreshAddressForm
    ? null
    : (matchedAddressByCartZip ?? customerAddress["regular"] ?? null);

  // Key that forces DeliveryAddressForm remount when address content changes,
  // not just when the address ID changes. Without this, editing an existing
  // address leaves the form key unchanged (same ID), react-hook-form never
  // re-reads defaultValues, and the order is placed with the old address (HL-10702/JG28KHFGI).
  const formKey = useFreshAddressForm
    ? `fresh-${zipCode}`
    : regularAddressForDisplay?.id
      ? `${regularAddressForDisplay.id}-${regularAddressForDisplay.address}-${regularAddressForDisplay.zip}-${regularAddressForDisplay.city}-${regularAddressForDisplay.first_name}-${regularAddressForDisplay.last_name}`
      : undefined;
  const isSelfPickup = cart.selected_service_option === "self_pickup";
  const isOnlyPrescription = cart.selected_service_option === "only_prescription";
  const isCannabisOrder = contentType === "cannabis";
  const isFlowzzFlow = cart.flow === ORDER_FLOWS.FLOWZZ_PRE_SELECTED;
  const isCannaleoFlow = cart.flow === ORDER_FLOWS.CANNALEO_PRE_SELECTED;
  const cannabisIdProduct = (cart.products ?? []).find(
    (product) => product.type === PRODUCT_TYPES.CANNABIS_ID,
  );
  const shouldApplyCouponToTotal = Boolean(cart.bonus_value)
    && !Boolean(cart.applied_subscription_discount)
    && !(Boolean(cart.only_prescription) && Boolean(cart.auto_bonus));
  const selectedShippingFee = getSelectedShippingFee({
    isExpressSelected: Boolean(expressDeliveryState.isSelected),
    expressShippingFee: Number(
      expressDeliveryState.deliveryPrice
      ?? cart.custom_shipping_fee
      ?? 0,
    ),
    isOtcOnlyFlow: cart.flow === Constants.ORDER_FLOWS.OTC_ONLY,
    otcShippingFee: Number(cart.custom_shipping_fee ?? otcOnlyShippingFee ?? 0),
    isSelfPickup,
    isOnlyPrescription: Boolean(cart.only_prescription),
    rxOnlyShippingFee: Number(cart.otc_price ?? 0) > 0
      ? Number(cart.shipping_fee ?? 0)
      : 0,
    regularShippingFee: Number(cart.shipping_fee ?? 0),
  });
  const shippingPageCartTotal = isCarePlusOrder
    ? carePlusCardProps.finalPrice
    : getShippingPageCartTotal({
        drugsPrice: cart.only_prescription ? 0 : Number(cart.drugs_price ?? 0),
        otcPrice: Number(cart.otc_price ?? 0),
        treatmentFee: Number(cart.treatment_fee ?? 0),
        consultationFee: Number(cart.consultation_fee ?? 0),
        serviceFee: Number(cart.service_fee ?? 0),
        carePlusPlanFee: Number(cart.care_plus_plan_fee ?? 0),
        shippingFee: selectedShippingFee,
        cannabisIdPrice: Number(cannabisIdProduct?.item_price ?? 0),
        bonusValue: shouldApplyCouponToTotal ? Number(cart.bonus_value) : 0,
        subscriptionDiscount: Number(cart.applied_subscription_discount ?? 0),
      });
  const isFreeTreatmentCart = isZeroOrderPrice(shippingPageCartTotal);
  const originalTreatmentFee = Number(cart.treatment_fee ?? 0);
  const shouldShowBannerOldPrice = isFreeTreatmentCart && originalTreatmentFee > 0;
  const submitButtonPlaceholder = isFreeTreatmentCart
    ? translator.translate(language, "shipping", "ShippingForm/complete_order_button_title")
    : undefined;
  const isFastApprovalInCart = useRef<boolean>(false);

  const leftPanelRef = useRef<HTMLDivElement | null>(null); // used to scroll to the top of the page on mobile

  // User click breakdown tracking
  const [openedTooltips, setOpenedTooltips] = useState<Set<string>>(new Set());
  const [userClicks, setUserClicks] = useState<Set<string>>(new Set());
  const hideToggleAddressAsBilling = isSelfPickup || (isOnlyPrescription && isCannabisCatalog);

  // Delivery address form default values
  const deliveryAddressDefaultValues = useMemo(() => {
    const expressAddress = useFreshAddressForm ? getExpressDeliveryAddress() : null;
    const savedExpressAddress = !useFreshAddressForm && !regularAddressForDisplay ? getExpressDeliveryAddress() : null;

    return {
      first_name: useFreshAddressForm ? "" : (regularAddressForDisplay?.first_name as string || ""),
      last_name: useFreshAddressForm ? "" : (regularAddressForDisplay?.last_name as string || ""),
      zip: useFreshAddressForm ? (expressAddress?.zip || zipCode) : (savedExpressAddress?.zip || (isExpressSelected && zipCode) || (regularAddressForDisplay?.zip as string) || ""),
      city: useFreshAddressForm ? (expressAddress?.city || "") : (savedExpressAddress?.city || (regularAddressForDisplay?.city as string) || ""),
      address: useFreshAddressForm ? (expressAddress?.street || "") : (savedExpressAddress?.street || (regularAddressForDisplay?.address as string) || ""),
      company: useFreshAddressForm ? "" : (regularAddressForDisplay?.company as string || ""),
      phone: useFreshAddressForm ? "" : (regularAddressForDisplay?.phone as string || ""),
      address_sub_type: useFreshAddressForm ? "" : (regularAddressForDisplay?.address_sub_type as string || "apartment"),
    };
  }, [useFreshAddressForm, zipCode, regularAddressForDisplay, isExpressSelected, getExpressDeliveryAddress]);

  const handleOutOfStockModalChooseAnother = () => {
      if (cart.came_from !== Constants.FLOWZZ_PREMIUM || !isAlternativeOfferTreatment) {
        navigate({
          pathname: `/select_treatment/${country}/${language}/${categoryCatalogMention}`,
          search: searchParams.toString()
        });
        return;
      }
      const params = new URLSearchParams(searchParams);
      ['p1', 'p2', 'p3', 'q1', 'q2', 'q3', 't1', 't2', 't3', 'oos'].forEach((key) => params.delete(key));
      if (!params.has('ec')) {
        params.append('ec', 'dnis-re');
      }
      const removedCannabisProductItemIds = outOfStockDataState.outOfStockData
        .filter((item) => item.newOTCQuantity === 0 && item.newProductItemId === 0)
        .map((item) => outOfStockDataState.originalProducts.find((product: CartProductView) => product.product_item_id === item.outOfStockProductItemId))
        .filter((product): product is CartProductView => product?.type === PRODUCT_TYPE_PRESCRIPTION_DRUG)
        .map((product) => product.product_item_id)
        .slice(0, MAX_CART_PRODUCTS);
      if (removedCannabisProductItemIds.length > 0) {
        params.set('alt', removedCannabisProductItemIds.join(','));
      }
      navigate({
        pathname: `/select_treatment/${country}/${language}/${categoryCatalogMention}`,
        search: `?${params.toString()}`
      });
    }

  // Reusable DHL Packstation Panel Component
  const dhlPackstationPanel = useMemo(() => {
    if (hidePackstation) return null;
    
    return (
      <DeliveryOptionPanel
        code={DHL_PACKSTATION}
        title={translator.translate(language, "my_account", `SubscriptionOrders/addressInfoCard/packstationAddress`)}
        isSelected={selectedOptionPanelCode === DHL_PACKSTATION}
        onPartnerPharmaciesOpen={() => setUserClicks(prev => new Set(prev).add(CLICK_PARTNER_PHARMACIES_POPUP))}
        onPharmacyDetailsExpand={() => setUserClicks(prev => new Set(prev).add(CLICK_PHARMACY_DETAILS_EXPAND))}
        onSelect={async () => {
          setSelectedOptionPanelCode(DHL_PACKSTATION);
          await handleDeliveryOptionChange("packstation");
        }}
        isDisabled={cart.only_prescription}
      >
        <DHLPackStationForm
          defaultValues={{
            first_name: customerAddress["packstation"]?.first_name as string,
            last_name: customerAddress["packstation"]?.last_name as string,
            address: customerAddress["packstation"]?.address as string,
            company: customerAddress["packstation"]?.company as string,
            phone: customerAddress["packstation"]?.phone as string,
            packstation_number: customerAddress["packstation"]?.packstation_number as string,
            packstation_address: customerAddress["packstation"]?.packstation_address as string,
            packstation_zip: customerAddress["packstation"]?.zip as string,
            packstation_city: customerAddress["packstation"]?.city as string,
          }}
          isGoogleAPILoaded={isGoogleAPILoaded}
        />
      </DeliveryOptionPanel>
    );
  }, [
    hidePackstation,
    language,
    selectedOptionPanelCode,
    cart.only_prescription,
    customerAddress,
    isGoogleAPILoaded,
    setSelectedOptionPanelCode,
    handleDeliveryOptionChange,
    setUserClicks
  ]);

  const initOtcPopup = ({ responseData, cartView, otcAddonsToSuggest }: { responseData: any; cartView: CartViewType; otcAddonsToSuggest: any[] }) => {
    const otcVariant = assignOtcPopupVariant(responseData.otcPopupABTestWeights, { country, isCarePlus: responseData.isCarePlus });
    setOtcPopupVariant(otcVariant);
    const otcRecommendations = suggestableOtcAddons<OtcPopupProduct>(responseData.OTCPopupRecommendations ?? [], cartView.products ?? [], cartView.allow_multiple_test_lab_kits);
    setOTCPopupRecommendations(otcRecommendations);
    const rxCartProduct = (cartView.products ?? []).find((p: CartProductView) => p.is_prescription_drug);
    const trackingContext: OtcPopupTrackingContext = { mixpanel_category: responseData.categoryMixpanelTitle ?? null, selected_product_catalog: rxCartProduct?.catalog_id ?? null, selected_product_item: rxCartProduct?.product_item_id ?? null };
    setOtcTrackingContext(trackingContext);
    // HL-12209: Cannabis self-pickup never gets the OTC popup, on any variant. On CT, pickup + Rx-only
    // becomes "only_prescription" and pickup + Rx & medication becomes "self_pickup".
    const isCannabisSelfPickup = responseData.contentType === "cannabis"
      && (cartView.selected_service_option === "self_pickup" || cartView.selected_service_option === "only_prescription");
    const willShow = !responseData.isCarePlus && !isCannabisSelfPickup && (
      otcVariant === "C" ? false :
      otcVariant === "B" ? otcRecommendations.length > 0 :
      otcAddonsToSuggest.length > 0
    );
    setShowOTCAddonsModal(willShow);
    if (willShow && otcVariant !== null) {
      trackOtcPopupDisplay(trackingContext);
    }
  };

  const initExpressDeliveryData = (cartView: any, expressStockCode: string | null, nextDayEligibility?: { isEligible: boolean; fee?: number } | null) => {

    const isExpressAvailable = cartView.isExpressFlow || cartView.flow === ORDER_FLOWS.OTC_ONLY;
    const isNextDayEligible = nextDayEligibility?.isEligible || false;
    const isExpressEnabled = expressStockCode ? true : false;

    const isExpress = cartView.selected_service_option === "express";
    setExpressDeliveryState((prevState) => ({
      ...prevState,
      isAvailable: isExpressAvailable || isNextDayEligible,
      isEnabled: isExpressEnabled,
      deliveryPriceLoading: isExpressEnabled || isNextDayEligible,
      isSelected: isExpress,
      selectedTier: isExpress ? (cartView.selected_express_tier ?? null) : null,
      isNextDayEligible,
      nextDayFee: nextDayEligibility?.fee || 0,
    }));

    isFastApprovalInCart.current = cartView.is_express_prescription_review || false;
  }
  // Fetching (handleGet)
  useEffect(() => {

    //On lending, remove the last email order id from local storage
    localStorage.removeItem("last_email_order_id");

    // Clear any sticky notifications from previous pages
    setStickyNotification({ show: false, title: "", content: "", level: "", showInfoIcon: false, autoFade: false });

    // Sent here from the payment page because the order's shipping method is no longer available
    if (searchParams.get("ec") === SEARCH_PARAM_FOR_SHIPPING_METHOD_UNAVAILABLE) {
      setStickyNotification({
        show: true,
        title: translator.translate(language, "default", "StickyNotification/shipping_method_unavailable_title"),
        content: translator.translate(language, "default", "StickyNotification/shipping_method_unavailable_description"),
        level: "warning",
        showInfoIcon: true,
        autoFade: true,
      });
    }

    const init = async () => {

    const lastOrderCountry = (window as any).eventsStorage.getFromCookie('last_order_country');
    if (lastOrderCountry && country && lastOrderCountry.toUpperCase() !== country.toUpperCase()) {
      window.eventsTracking.setData('last_order', '');
      (window as any).eventsStorage.addToCookie('last_order_country', '');
    }

    let cartSessionFields = getSessionFields();

    if (!cartSessionFields.id) {
      // iPhone Chrome back: the cart is cleared on shipping submit and the payment
      // back-handler never runs there, so recover the cart from the just-placed order.
      const lastOrder = window.eventsTracking.getData("last_order");
      // session-scoped "just submitted shipping" marker — absent on a fresh/unrelated visit
      const justShipped = !!SessionStorageWrapper.getItem("last_shipped_cart");
      if (lastOrder && justShipped) {
        try {
          await restoreCartFromOrder(country!, language!, lastOrder);
          cartSessionFields = getSessionFields();
        } catch (error) {
          window.clientLogger.error("Shipping back-recovery: restore-cart failed", error, { orderHash: lastOrder });
        }
        if (!cartSessionFields.id) {
          // restore failed or returned no cart → localized order page (order is payable there)
          navigate({ pathname: `/${country}/account/my-orders/${lastOrder}/details`, search: "showRedirectModal=true" }, { replace: true });
          return;
        }
      } else {
        window.clientLogger.warn("ShippingRouter failed, cartSessionFields.id is not set");
        navigate("/404");
        return;
      }
    }

    if (cartSessionFields?.id && (SessionStorageWrapper.getItem("last_shipped_cart") === cartSessionFields?.id)) {
      window.clientLogger.warn("ShippingRouter failed, cartSessionFields.id is the same as last_shipped_cart")
      navigate("/404");
      return
    }

    // Scroll to the top of the page
    window.scrollTo(0, 0);

    const fetchData = async () => {
      await loadGoogleApi(() => {
        setIsGoogleAPILoaded(true);
      });

      const forceRxSelfPickup = localStorage.getItem('force_rx_self_pickup') === '1';
      const shippingQuery = new URLSearchParams();
      if (forceRxSelfPickup) shippingQuery.set('force_rx_self_pickup', '1');
      // "Test Lab Multi Test AB": the arm rolled on the CMS pages is stored on a funnel-created cart by the api.
      const testLabMultiTestVariant = readTestLabMultiTestVariant();
      if (testLabMultiTestVariant) shippingQuery.set('test_lab_multi_test_variant', testLabMultiTestVariant);
      const endPointURL = `v2/shipping/${country}/${language}${shippingQuery.toString() ? `?${shippingQuery.toString()}` : ''}`


      setIsLoading(true);

      // Fetch Data (And init the states in the provider)
      http.getFromServer(endPointURL, [http.MIDDLEWARES.CART_ORDER, http.MIDDLEWARES.CUSTOMER_ID])
        .then(async (response: any) => {

          // Care+ orders always render the V3 shipping page (V3 won the weight_loss_v3 test). Both flags
          // together, before the awaits below, so the legacy header doesn't flash in between.
          // HL-11156: Care+ also hides the OTC popup (its cart/breakdown can't list OTC addons).
          setIsCarePlusOrder(response.data.isCarePlus);
          setShippingSettingsLoaded(true);
          setIsCannabisCatalog(response.data.isCannabisCatalog);
          setIsExpressFlow(response.data.cartView?.isExpressFlow ?? false);
          // Set headerVersion based on isCannabisCatalog
          if (response.data.isCannabisCatalog) {
            setHeaderVersion('v2');
          } else {
            setHeaderVersion('v1');
          }
          // 1. Set the provider's states
          const responseData = response.data;
          const cartView = responseData.cartView as CartViewType;
          // "Test Lab Multi Test AB": the arm (cookie, or the one the api just rolled) sets the kit rule for this page -
          // A = one kit, one unit; B = several. Every quantity gate on the page reads this one flag. No arm: the
          // server's per-country flag stays.
          const testLabMultiTestVariant = resolveTestLabMultiTestVariant(responseData.testLabMultiTestVariant);
          if (testLabMultiTestVariant) cartView.allow_multiple_test_lab_kits = testLabMultiTestVariant === "B";
          // Page View event
          SocialMediaTracker.track("pv", SHIPPING_PAGE_VIEW_EVENT, {
            searchParamas: Object.fromEntries(searchParams.entries()),
          });

          if (cartView.consultation_type === "video" && !cartView.timekitBooking) {
            navigate({ pathname: `/choose-doctor/${country}/${language}/${responseData.categoryCatalogMention}`, search: searchParams.toString() }, { replace: true });
          }
          const isCannabis = responseData.contentType === "cannabis";

          const isOnlyPrescriptionProducts = cartView.products.filter((product: any) => product.type === PRODUCT_TYPES.PRESCRIPTION_DRUG).every((product: any) => product.only_prescription);
          setshowUpsellOnShippingPage(cartView.flow === ORDER_FLOWS.FLOWZZ_PRE_SELECTED || isOnlyPrescriptionProducts);
            setIsOriginalCartFlowFlowzz(cartView.flow === ORDER_FLOWS.FLOWZZ_PRE_SELECTED);
            setForceFreeTreatmentFeeCoupon(responseData.forceTreatmentFeeDiscount);
            
            // Parse weights if it's a JSON string
            if (responseData.upsellABCtestWeights) {
              try {
                const weights = typeof responseData.upsellABCtestWeights === 'string'
                  ? JSON.parse(responseData.upsellABCtestWeights)
                  : responseData.upsellABCtestWeights;
                setUpsellABCtestWeights(weights);
              } catch (e) {
                setUpsellABCtestWeights(null);
              }
            }
          initExpressDeliveryData(cartView, responseData.expressStockCode, responseData.nextDayEligibility);
          setExpressStockCode(responseData.expressStockCode);
          setCountryCurrenciesByID(responseData.countryCurrenciesByID);
          handleDefaultCartCurrency(responseData.countryCurrenciesByID);
          saveCart({...cartView, timekitBooking: cartView.timekitBooking || null});

          // A/B Test - Stripe Link: DE + service_fee CONTROL bucket + not self-pickup
          const stripeLinkEligible =
            country?.toUpperCase() === 'DE' &&
            localStorage.getItem('abtest_service_fee_test') === 'A' &&
            cartView.selected_service_option !== 'self_pickup';
          const stripeLinkWeight = stripeLinkEligible && responseData.stripeLinkABTestVariable != null
            ? Number(responseData.stripeLinkABTestVariable)
            : NaN;
          if (stripeLinkEligible && stripeLinkWeight >= 0 && stripeLinkWeight <= 1) {
            new ABTestManager({
              testName: 'stripe_link',
              variants: ['A', 'B'],
              weights: [1 - stripeLinkWeight, stripeLinkWeight],
            });
          }

          if ((cartView.fast_approval_fee ?? 0) > 0) {
            setIsExpressPrescriptionReview(true);
          }

          const customerAddresses = responseData.customerAddresses;
          const allAddresses = customerAddresses.all || [];
          const cartZip = (cartView.zipcode ?? "").trim();
          const isExpress = !!cartView.shipping_company_code
          && EXPRESS_SHIPPING_COMPANIES.includes(cartView.shipping_company_code);
          // same carrier-independent rule as the render-time decision below.
          const hasChosenZip = !!cartZip && (isExpress || !!getExpressDeliveryAddress()?.zip);
          const matchedAddressByCartZip =
            responseData.isReturningCustomer === true && hasChosenZip
              ? findRegularAddressByZip(allAddresses, cartZip)
              : null;
          setCustomerAddress(
            matchedAddressByCartZip
              ? { ...customerAddresses, regular: matchedAddressByCartZip }
              : customerAddresses,
          );
          setAllCustomerAddresses(allAddresses);
          setIsReturningCustomer(responseData.isReturningCustomer === true);
          setPreSelectedExternalPharmacy(responseData.preSelectedExternalPharmacy);
          setSelfPickupPharmacySettings(responseData.selfPickupPharmacySettings);
          if (responseData.rxSelfPickup) {
            setRxSelfPickup(responseData.rxSelfPickup);
          }
          if (cartView.selected_service_option === 'self_pickup') {
            setRxSelfPickupServiceOption(SELF_PICKUP_PAYMENT_MODELS.PRESCRIPTION_ONLY);
            // Restore the selected pharmacy code from the saved pharmacy_id so the
            // summary row shows the pharmacy name after back-navigation / page refresh.
            if (cartView.self_pickup_pharmacy_id && responseData.rxSelfPickup) {
              const allCards = cartView.only_prescription
                ? responseData.rxSelfPickup.prescriptionOnlyPharmacyCards
                : responseData.rxSelfPickup.pharmacyCards;
              const restoredCode = Object.keys(allCards ?? {}).find(
                (code) => allCards[code].pharmacy_id === cartView.self_pickup_pharmacy_id
              );
              if (restoredCode) setSelectedPickupPharmacyCode(restoredCode);
            }
          }
          setHidePackstation(responseData.hidePackstation);
          setContentType(responseData.contentType);
          setTestLabSampleType(responseData.testLabSampleType ?? null);
          setIsMixedOtcTestLabCart(responseData.isMixedOtcTestLabCart || false);
          setSaleVoucherRequired(responseData.saleVoucherRequired);
          setCategoryCatalogMention(responseData.categoryCatalogMention);
          // HL-12264: UK tracked prices in GBP. The rate is read from this response —
          // cartCurrency in this closure predates handleDefaultCartCurrency above.
          const trackingCurrencyRate = Object.values<CountryCurrency>(responseData.countryCurrenciesByID ?? {})
            .find((currency) => currency.isDefault)?.rate ?? 1;
          const carePlusTrackingProps = responseData.isCarePlus ? {
            // HL-12122: V3 Monthly is not a Care+ tier — only WL2 Care+ orders carry `tier`.
            ...(cartView.care_plus_plan_type === "monthly" ? {} : { tier: cartView.care_plus_plan_tier ?? null }),
            plan_duration: cartView.care_plus_plan_period_months ?? null,
            is_one_time: !cartView.subscription_plan_id,
            plan_fee: toChargeCurrency(Number(cartView.care_plus_plan_fee ?? 0), trackingCurrencyRate, country),
            medication_price: toChargeCurrency(lineFromProducts(cartView.products ?? [])?.item_price ?? null, trackingCurrencyRate, country),
            // HL-12264: no plan_variant on UK V3; every other country keeps it.
            ...(country?.toUpperCase() === "GB" ? {} : { plan_variant: null }),
            plan_type: cartView.care_plus_plan_type ?? null, // HL-12122
          } : {};
          // HL-10959: Care+ A/B arm + first-touch entry_point on shipping PV
          registerWlExperimentSuperProperties();
          // Keep the arm in the cookie so every later request and the CMS pages use the same one, and report the
          // assignment once when the api just rolled it (visitor who entered the funnel directly).
          if (testLabMultiTestVariant) {
            writeTestLabMultiTestCookie(testLabMultiTestVariant);
            if (responseData.testLabMultiTestVariantAssigned === true) {
              trackTestLabMultiTestAssignment(testLabMultiTestVariant);
            }
          }
          registerTestLabMultiTestSuperProperty(testLabMultiTestVariant);
          // HL-12122: shipping is behind login, so a guest who signed in at checkout gets the
          // right customer_status here (the questionnaire computed it while they were a guest).
          registerCustomerStatus(responseData.customerStatus);
          const isFreeTreatmentCartView = isZeroOrderPrice(getCartViewPayableTotal(cartView));
          // HL-11003: the arm comes from localStorage, so the cart may need reconciling in either
          // direction before prices render. isLoading only clears in .finally, after this await.
          let autoCatalogCouponVariant: string | null = null;
          const autoCatalogCouponWeight = resolveAutoCatalogCouponWeight(responseData.abtestAutoCatalogCouponWeight);
          if (isAbtestAutoCatalogCouponParticipant({
            isCatalogEnabled: responseData.abtestAutoCatalogCouponEnabled === true,
            isReturningCustomer: responseData.isReturningCustomer,
            cart: cartView,
            weight: autoCatalogCouponWeight,
          })) {
            const variant = resolveAutoCatalogCouponVariant(autoCatalogCouponWeight);
            try {
              const reconcileResponse = await http.postToServer(
                ABTEST_AUTO_CATALOG_COUPON_ENDPOINT,
                { variant },
                [http.MIDDLEWARES.CART_ORDER, http.MIDDLEWARES.CUSTOMER_ID],
              );
              const reconciledCartView = reconcileResponse?.data?.cartView;
              if (reconciledCartView) {
                // Merged, not replaced: the reconcile only touches bonus fields, and the shipping GET's
                // cartView carries extras (isExpressFlow) the reconcile response doesn't repeat.
                saveCart({ ...cartView, ...reconciledCartView, timekitBooking: reconciledCartView.timekitBooking || null });
              }
              autoCatalogCouponVariant = variant;
            } catch (error) {
              // Never break the shipping page over the experiment — fall back to the control flow.
              autoCatalogCouponVariant = null;
            }
          }
          setAbtestAutoCatalogCoupon({
            variant: autoCatalogCouponVariant,
            eligibleForCoupon: !isAbtestAutoCatalogCouponArm(autoCatalogCouponVariant),
          });
          // HL-12122: one shared event for every funnel version (no separate "V3 CarePlus" name).
          MainTracker.track("pv", "View Page: shipping", {
            ...buildAbtestAutoCatalogCouponProps(autoCatalogCouponVariant),
            "Delivery method": resolveDeliveryMethodLabel(cartView),
            "Delivery price": toChargeCurrency(resolveDeliveryPriceEuros(cartView), trackingCurrencyRate, country),
            ...carePlusTrackingProps,
            ...getWlExperimentTrackingProps(),
            ...getTestLabMultiTestTrackingProps(testLabMultiTestVariant),
            [MIXPANEL_IS_FREE_TREATMENT]: isFreeTreatmentCartView,
            ...getFlowzzTrackingProps(),
          });
          setAllowPrescriptionRedemption(responseData.allowPrescriptionRedemption);
          setIsSubscriptionAlreadyPicked(responseData.isSubscriptionAlreadyPicked);
          // One Test Lab kit per order (HL-9979): once a kit is in the cart every test-lab
          // suggestion renders with "+" disabled, so don't suggest what can't be added.
          const otcAddonsToSuggest = suggestableOtcAddons(responseData.OTCAddonsProducts, cartView.products ?? [], cartView.allow_multiple_test_lab_kits);
          setOTCAddonsProducts(otcAddonsToSuggest);
          initOtcPopup({ responseData, cartView, otcAddonsToSuggest });
          setUriForOutOfStock(responseData.redirectRouteForOutOfStock?.uri);
          setOtcOnlyShippingFee(responseData.otcShippingFeeValue);
          setPharmaciesModalInfo && setPharmaciesModalInfo(responseData.pharmaciesModalInfo || null);
          setAllPharmaciesLocations(responseData.allPharmaciesAddresses);
          setProductsGroupedByPharmacy(responseData.productsGroupedByPharmacy);
          setIsFastApprovalFlow(responseData.isFastApprovalFlow);
          setIsFlowzzFastApprovalOffer(Boolean(responseData.isFlowzzFastApprovalOffer));
          // Stale variant from the retired HL-7400 test (HL-10299); drop once old browsers have cycled.
          localStorage.removeItem('abtest_ed_package_station_test');
          setUrbifyRolloutPercentage(responseData.urbifyRolloutPercentage);
          if (responseData.rxSelfPickup) {
            setRxSelfPickup(responseData.rxSelfPickup);
          }
          const isSwissCannabis = isCannabis && country?.toUpperCase() === "CH";
          setDigitalCannabisIDState(current => ({
            ...current,
            showWidget: isCannabis && !isSwissCannabis,
            isToggleEnabled: cartView.products.some((product: CartProductView) => (product.title.trim() === responseData.cannabisIDProductItem.title?.trim())),
            productItem: responseData.cannabisIDProductItem
          }));

          setExpressDeliveryState((prevState) => ({
            ...prevState,
            bonus: responseData.expressShippingFee,
            shippingMethodToProductIDs: { [responseData.expressShippingMethodID]: cartView.products.map((p: CartProductView) => p.product_item_id) },
            expressPharmacyName: responseData?.expressPharmacyName || null,
          }));
          setStandardShippingMethodID(responseData.standardShippingMethodID ?? null);
          setSelfPickupShippingMethodID(responseData.selfPickupShippingMethodID ?? null);

          setIdentityCheckState(current => ({
            ...current,
            showWidget: responseData.contentType === "cannabis" || responseData.isCarePlus,
          }));
          // 2. Upsell Popup
          if (responseData.showUpsellPopUp) {
            setShowUpsellPopUp(true);
            setIsFlowzzMoreExpensive(responseData.isFlowzzMoreExpensive);
            setUpsellSaveAmount(responseData.upsellSaveAmount || 0);
            setFinalAlternativeProducts(responseData.finalAlternativeProducts);
            setUpsellProducts(responseData.upsellProducts);
            setEligibleForUpsell(true);
          } else if (responseData.showUpsellPopUp === false) {
            window.eventsTracking.track({ e: "Upsell Popup does not appear", p: {notShowUpsellPopUpReason: responseData?.notShowUpsellPopUpReason } });
          }

          // 3. OTC Popups
          const hasOTCProducts = cart.products.some((product: CartProductView) => product.type === PRODUCT_TYPES.FREE_DRUG || product.type === PRODUCT_TYPES.TEST_KIT);
          if(cart.flow === ORDER_FLOWS.OTC_ONLY){
            setShowOtcCartPopUp(true);
          }else if(hasOTCProducts){
            setShowOtcCartPopUp(true);
          }else{
            setShowOtcCartPopUp(false);
          }

          // 4. Pre-fill "Deep link coupon" if there is one (skip if the cart was upgraded to premium — the upsell discount takes priority)
          // If a delivery method is already selected on load (e.g. UK with a single option), also auto-apply immediately.
          // Countries with multiple delivery options (e.g. DE) will have selected_service_option null on load —
          // the coupon will be applied by handleDeliveryOptionChange once the user picks a method.
          const deeplinkCoupon = searchParams.get('cpn') || cartView.bonus_coupon_code || sessionStorage.getItem('cpn');
          if (!forceFreeTreatmentFeeCoupon) {
            if (deeplinkCoupon && !cartView.auto_bonus && !cartView.applied_subscription_discount && !cart.auto_bonus && !cartView.upgraded_to_premium) {
              setCouponWidgetState((current) => ({ ...current, inputCode: deeplinkCoupon }));
              if (cart.selected_service_option) {
                const isExpressSelectedOnLoad = cart.selected_service_option === "express";
                handleApplyCoupon({inputCode: deeplinkCoupon, isExpressSelected: isExpressSelectedOnLoad, shouldOverrideCartBonuses: true});
                setIsDeepLinkCouponApplied(true);
              }
            }
          }
        })
        .catch((error) => {

          if (error.response.status === 400 && error.response.data.status === "monthly_cannabis_purchased_quantity_limit_exceeded") {
            const mention = error.response.data.mention;
            searchParams.set('mcpqle', "true");
            navigate({ pathname: `/select_treatment/${country}/${language}/${mention}`, search: searchParams.toString() });
            return;
          }
          //TODO: handle errors
          setErrorStatus(500);
        })
        .finally(() => {
          setIsLoading(false);
          setFinishedFetching(true);
        })
    };

    fetchData();

    // 3. scroll to the top of the page (desktop) or the left panel (mobile)
    setTimeout(() => {
      if (window.innerWidth < 1024) { // Check if on mobile (below lg breakpoint)
        leftPanelRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      else {
        window.scrollTo(0, 0);
      }
    }, 200)

    };

    init();
  }, []);


  // Refs to hold current values for the popstate handler (avoids stale closures)
  const backNavigationRef = useRef({
    consultationType: cart.consultation_type,
    country,
    language,
    categoryCatalogMention,
    searchParams,
    flow: cart.flow,
  });

  // Keep refs updated with latest values
  useEffect(() => {
    backNavigationRef.current = {
      consultationType: cart.consultation_type,
      country,
      language,
      categoryCatalogMention,
      searchParams,
      flow: cart.flow,
    };
  }, [cart.consultation_type, country, language, categoryCatalogMention, searchParams, cart.flow]);

  // This useEffect is used to handle the back button of the browser on the shipping page
  // Push a history entry so back button works even if user landed directly on this page
  useEffect(() => {
    // Push a state so we have something to "go back" from
    window.history.replaceState({ page: 'shipping' }, '', window.location.href);

    const handlePopState = () => {
      const { consultationType, country, language, categoryCatalogMention: mention, searchParams: sp, flow } = backNavigationRef.current;

      switch (true) {
        // 1. Video consultation => choose doctor and appointment page
        case consultationType === "video":
          navigate({pathname: `/choose-doctor/${country}/${language}/${mention}`, search: sp.toString()}, { replace: true });
          break;

        case mention === "online-vd":
        // 2. Online video consultation => questionnaire page
          navigate(
            {pathname: `/questionnaire/${country}/${language}/${mention}`, search: sp.toString()},
            { replace: true }
          );
          break;

        // 3. Reorder => don't do anything
        case Boolean(sp.get("reorder")):
          // Navigate back again to actually go back
          window.history.back();
          break;

        // 4. OTC-only => go back to the CMS page the user came from
        case flow === ORDER_FLOWS.OTC_ONLY:
          window.history.back();
          break;

        // 5. Regular treatment => select treatment page
        default:
          navigate(
            {pathname: `/select_treatment/${country}/${language}/${mention}`, search: sp.toString()},
            { replace: true }
          );
          break;
      }
    }
    
    // Use addEventListener instead of window.onpopstate to avoid being overwritten by PageTracker
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    }
  }, []);

  const handleContinueClick = useCallback(() => {
    sessionStorage.setItem('paymentEventSent', uniqueSessionId);
    if (abtestAutoCatalogCoupon.variant) {
      MainTracker.track("click", ABTEST_AUTO_CATALOG_COUPON_EVENT,
        buildAbtestAutoCatalogCouponContinueProps(abtestAutoCatalogCoupon.variant, abtestAutoCatalogCoupon.eligibleForCoupon));
    }
  }, [uniqueSessionId, abtestAutoCatalogCoupon.variant, abtestAutoCatalogCoupon.eligibleForCoupon]);

  // Memoized click handler to prevent recreation on every render
  const handleOTCAddonsClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    // Care+ shipping: OTC addons modal disabled (HL-11156).
    if (isCarePlusOrder) return;
    setShowOtcCartPopUp(false);
    setShowOTCAddonsModal(true);
  }, [isCarePlusOrder, setShowOtcCartPopUp, setShowOTCAddonsModal]);



  // Memoized OTCAddonsTriggerChild to prevent unnecessary re-renders
  const OTCAddonsTrigger = useMemo(() => {
    // Care+ shipping: no OTC addons entry point (HL-11156 — SP cart can't show them properly).
    // HL-12209: no entry point for Cannabis self-pickup either, also after switching to it on this page.
    const isCannabisSelfPickup = isCannabisOrder && (isSelfPickup || isOnlyPrescription);
    const otcProductsCount = otcPopupVariant === "B" ? OTCPopupRecommendations.length : OTCAddonsProducts.length;
    const showOtcAddonsTrigger = !isCarePlusOrder && !isCannabisSelfPickup && otcProductsCount > 0;

    return (
      <>
        {/* OTC Addons Trigger  */}
        {showOtcAddonsTrigger && (
          <button
            key="otc-addons-modal-trigger"
            id='otc-addons-modal-trigger'
            type='button'
            className="open-otc-addons-modal rounded-[12px]"
            onClick={handleOTCAddonsClick}
          >
            {translator.translate(language, "default", "OrderWindow/otc_modal_trigger")}
          </button>
        )}
      </>
    );
  }, [isCarePlusOrder, isCannabisOrder, isSelfPickup, isOnlyPrescription, OTCAddonsProducts.length, handleOTCAddonsClick, language, otcPopupVariant, OTCPopupRecommendations.length]);

  
  if (!finishedFetching || !cart.id) {
    return <></>
  }

  const carePlusAddressForm = (
    <div id="shipping-page-left-panel" ref={leftPanelRef} className="flex h-fit w-full flex-col gap-y-4 rounded-[6px]">
      {isPackstationFirst && dhlPackstationPanel}
      <DeliveryOptionPanel
        code={PERSONAL_ADDRESS}
        title={
          cart.selected_service_option === "self_pickup"
            ? translator.translate(language, "shipping", "serviceOptions/pickup_from_pharmacy")
            : translator.translate(language, "my_account", "SubscriptionOrders/addressInfoCard/personalAddress")
        }
        isSelected={selectedOptionPanelCode === PERSONAL_ADDRESS}
        onPartnerPharmaciesOpen={() => setUserClicks(prev => new Set(prev).add(CLICK_PARTNER_PHARMACIES_POPUP))}
        onPharmacyDetailsExpand={() => setUserClicks(prev => new Set(prev).add(CLICK_PHARMACY_DETAILS_EXPAND))}
        hideOptionCards={categoryCatalogMention === "online-vd"}
        onSelect={() => setSelectedOptionPanelCode(PERSONAL_ADDRESS)}
        hideHeader={hidePackstation || Boolean(preSelectedExternalPharmacy) || Boolean(selfPickupPharmacySettings)}
        isOtcOnlyFlow={cart.flow === Constants.ORDER_FLOWS.OTC_ONLY}
      >
        {regularAddressForDisplay && !useFreshAddressForm && (
          <DeliveryAddressCard
            address={regularAddressForDisplay.address as string}
            city={regularAddressForDisplay.city as string}
            phone={regularAddressForDisplay.phone as string}
            addressSubType={regularAddressForDisplay.address_sub_type as string}
            label={translator.translate(language, "shipping", "layout/living_address") || "Delivery address"}
            onClick={() => setShowAddressesModal(true)}
          />
        )}
        <DeliveryAddressForm
          key={formKey}
          showToggle={!hideToggleAddressAsBilling}
          defaultValues={deliveryAddressDefaultValues}
          isGoogleAPILoaded={isGoogleAPILoaded}
          isAddressCardMode={!!regularAddressForDisplay && !useFreshAddressForm}
          orangeToggle
        />
      </DeliveryOptionPanel>
      {!isPackstationFirst && dhlPackstationPanel}
    </div>
  );

  // A subscription order is discounted by its plan only; the API refuses coupons on it (coupon_not_allowed_for_subscription).
  const showCouponInput = !cart.auto_bonus && !cart.subscription_plan_id;
  const carePlusCouponControl = saleVoucherRequired ? <SaleVoucherWidget /> : showCouponInput ? <CouponWidgetV2 /> : null;

  const carePlusCartSummary = (
    <CarePlusShippingCartCard
      {...carePlusCardProps}
      t={carePlusT}
      medication={carePlusMedication}
      currencyLocale={cartCurrency.locale}
      currencyRate={cartCurrency.rate}
      fullTierName
    />
  );

  const carePlusCostBreakdown = (
    <CarePlusCostBreakdown
      t={carePlusT}
      rows={carePlusCostBreakdownRows}
      currencyLocale={cartCurrency.locale}
      currencyRate={cartCurrency.rate}
      onToggle={(isOpen) => MainTracker.track("custom", "Click Cost Details", {
        page: "Shipping",
        state: isOpen ? "open" : "close",
      })}
    />
  );

  const carePlusCta = (
    <StickySubmit
      submitButtonLoading={isSubmitButtonDisabled}
      formID={selectedFormID}
      isButtonDisabled={!cart.selected_service_option}
      buttonBackgroundColor="linear-gradient(90deg, #f59200 0%, #ffbb29 100%)"
      onSubmit={() => sessionStorage.setItem('paymentEventSent', uniqueSessionId)}
    >
      {identityCheckState?.showWidget ? (
        <TogglePrecaution
          isToggleEnabled={identityCheckState.isPrecautionToggleEnabled}
          precautionLevel={identityCheckState.precautionLevel}
          updateToggle={() => setIdentityCheckState(current => ({
            ...current,
            precautionLevel: "info",
            isPrecautionToggleEnabled: !current.isPrecautionToggleEnabled,
          }))}
          isCannabisCatalog={isCannabisCatalog}
          isOnlyPrescription={cart.only_prescription}
          onTermsLinkClick={() => setUserClicks(prev => new Set(prev).add(CLICK_TERMS_LINK))}
          orange
        />
      ) : undefined}
    </StickySubmit>
  );

  return (
    <>

      {isDeepLinkCouponApplied && cart.bonus_value && !cart.applied_subscription_discount ? <div id='bonus-banner' className='bg-[#269C6E]/90 text-white text-[14px] py-2 px-1 text-center font-roboto top-0 pin-below-app-bar fixed w-full z-10'>{translator.translate(language, "default", "BonusBanner/text")}</div> : null}

        {/* OTCs Modal — suppressed for Care+ (HL-11156): SP cart breakdown does not list OTC
            addons correctly. Non-Care+ shipping keeps the popup as-is. */}
        {!isCarePlusOrder && (
        <PortaledModal
          shouldBackgroundClickHideModal={true}
          shouldShowModal={showOTCAddonsModal}
          hideModal={() => {
            setShowOTCAddonsModal(false);
            setExpressDeliveryState({...expressDeliveryState, deliveryPriceLoading: true});
          }}
          showModal={() => setShowOTCAddonsModal(true)}
        >
          {otcPopupVariant === "B" ? (
            <OTCPopupV3
              products={OTCPopupRecommendations}
              language={language!}
              country={country!}
              trackingContext={otcTrackingContext}
              isCarePlus={isCarePlusOrder}
              hideModal={() => {
                setShowOTCAddonsModal(false);
                setExpressDeliveryState({...expressDeliveryState, deliveryPriceLoading: true});
              }}
            />
          ) : (
          <OTCAddonsModalV2
            productItems={OTCAddonsProducts}
            title={translator.translate(language, "shipping", "OTCAddonsModal/title")}
            language={language!}
            trackingContext={otcPopupVariant ? otcTrackingContext : undefined}
            hideModal={() => {
              setShowOTCAddonsModal(false);
              setExpressDeliveryState({...expressDeliveryState, deliveryPriceLoading: true});
            }}
          />
          )}
        </PortaledModal>
        )}
      
        {/* Reschedule Video Consultation Modal */}
        {country && language && cart.catalog_id && (
          <RescheduleVideoConsultationModal
            country={country}
            language={language}
            catalogID={cart.catalog_id}
            shouldShow={showRescheduleVideoConsultationModal}
            onClose={() => setShowRescheduleVideoConsultationModal(false)}
          />)
        }

        {/* Customer Addresses Modal */}
        <CustomerAddressesModal
          isOpen={showAddressesModal}
          onClose={() => setShowAddressesModal(false)}
          addresses={allCustomerAddresses.filter((a: any) => a.address_type !== "packstation")}
          defaultAddressId={regularAddressForDisplay?.id ?? customerAddress?.regular?.id}
          title={translator.translate(language, "shipping", "CustomerAddressesModal/title") || "Wählen Sie eine Lieferadresse"}
          addAddressLabel={translator.translate(language, "shipping", "CustomerAddressesModal/add_address") || "Add address"}
          onSelectAddress={(addr) => {
            setCustomerAddress({ ...customerAddress, regular: addr });
            if (shouldQuoteExpressOnAddressChange({ isAvailable: expressDeliveryState.isAvailable, isCannabisCatalog }) && addr.zip) {
              updateCartZipcode(addr.zip);
            }
            if (!isAddressPhoneValid(addr, language || "")) {
              setInvalidPhoneAddress(addr);
            }
            MainTracker.track("custom", "Funnel Change Address", {
              address_amount: allCustomerAddresses.filter((a: CustomerAddress) => a.address_type === "regular").length,
              add_address: "no",
              use_geo_location: "no",
              category: categoryCatalogMention,
            });
          }}
          onAddNewAddress={() => { setShowAddressesModal(false); setAddressToEdit(null); setShowAddNewAddressModal(true); }}
          onEditAddress={(addr) => { setShowAddressesModal(false); setAddressToEdit(addr as AddressToEdit); setShowAddNewAddressModal(true); }}
          isMobile={isMobile}
        />

        {/* RX Self-Pickup pharmacy picker sheet */}
        <SelfPickupPharmacySheet
          isOpen={isPickupSheetOpen}
          onClose={() => setIsPickupSheetOpen(false)}
        />

        <AddNewAddressModal
          isOpen={showAddNewAddressModal}
          onClose={() => { setShowAddNewAddressModal(false); setAddressToEdit(null); }}
          onBack={() => { setShowAddNewAddressModal(false); setAddressToEdit(null); setShowAddressesModal(true); }}
          isMobile={isMobile}
          onSuccess={(updatedAddresses, meta) => {
            setAllCustomerAddresses(updatedAddresses.all || []);
            const newlyAdded = meta.isNew && updatedAddresses.all?.length
              ? updatedAddresses.all.reduce((latest: any, addr: any) => addr.id > latest.id ? addr : latest, updatedAddresses.all[0])
              : null;
            const addressesToSet = newlyAdded
              ? { ...updatedAddresses, regular: newlyAdded }
              : updatedAddresses;
            setCustomerAddress(addressesToSet);
            if (shouldQuoteExpressOnAddressChange({ isAvailable: expressDeliveryState.isAvailable, isCannabisCatalog }) && addressesToSet.regular?.zip) {
              updateCartZipcode(addressesToSet.regular.zip);
            }
            const trackingProps: Record<string, any> = {
              address_amount: (updatedAddresses.all || []).filter((a: CustomerAddress) => a.address_type === "regular").length,
              add_address: meta.isNew ? "yes" : "no",
              use_geo_location: meta.usedGeoLocation ? "yes" : "no",
              category: categoryCatalogMention,
            };
            MainTracker.track("custom", "Funnel Change Address", trackingProps);
            setTimeout(() => {
              setStickyNotification({
                show: true,
                title: "",
                content: translator.translate(language, "shipping", "AddNewAddressModal/save_success") || "Address saved successfully",
                level: "success",
                showInfoIcon: false,
                autoFade: true,
              });
            }, 150);
          }}
          addressToEdit={addressToEdit}
          onDelete={(deletedAddressId) => {
            const remainingAddresses = allCustomerAddresses.filter((a: any) => a.id !== deletedAddressId);
            setAllCustomerAddresses(remainingAddresses);

            if (remainingAddresses.length > 0) {
              const lastAdded = remainingAddresses.reduce((latest: any, addr: any) => addr.id > latest.id ? addr : latest, remainingAddresses[0]);
              setCustomerAddress({ ...customerAddress, regular: lastAdded });
              if (shouldQuoteExpressOnAddressChange({ isAvailable: expressDeliveryState.isAvailable, isCannabisCatalog }) && lastAdded.zip) {
                updateCartZipcode(lastAdded.zip);
              }
              setShowAddressesModal(true);
            } else {
              setCustomerAddress({ ...customerAddress, regular: null });
            }

            setStickyNotification({
              show: true,
              title: "",
              content: translator.translate(language, "shipping", "AddNewAddressModal/delete_success") || "Address deleted successfully",
              level: "success",
              showInfoIcon: false,
              autoFade: true,
            });
          }}
        />

        <InvalidPhonePopup
          isOpen={!!invalidPhoneAddress}
          address={invalidPhoneAddress}
          isMobile={isMobile}
          onClose={() => setInvalidPhoneAddress(null)}
          onSaved={(updatedAddresses, updatedAddressID) => {
            const nextAll = updatedAddresses.all || [];
            setAllCustomerAddresses(nextAll);
            const updatedRegular = nextAll.find((a: any) => a.id === updatedAddressID);
            if (updatedRegular) {
              setCustomerAddress({ ...customerAddress, regular: updatedRegular });
              if (shouldQuoteExpressOnAddressChange({ isAvailable: expressDeliveryState.isAvailable, isCannabisCatalog }) && updatedRegular.zip) {
                updateCartZipcode(updatedRegular.zip);
              }
            }
            setInvalidPhoneAddress(null);
            setStickyNotification({
              show: true,
              title: "",
              content: translator.translate(language, "shipping", "AddNewAddressModal/save_success") || "Address saved successfully",
              level: "success",
              showInfoIcon: false,
              autoFade: true,
            });
          }}
        />

        <OutOfStockModal
          isOpen={outOfStockDataState.outOfStockData.length > 0}
          onClose={() => {
            setOutOfStockDataState({
              outOfStockData: [],
              originalProducts: cart.came_from === Constants.FLOWZZ_PREMIUM ? outOfStockDataState.originalProducts : []
            });
          }}
          onChooseAnother={handleOutOfStockModalChooseAnother}
          language={language!}
        />



      {/* Upsell Popup */}
      {showUpsellPopUp && Object.keys(finalAlternativeProducts).length > 0 && (
        <UpsellPopUp 
          handleDeliveryOptionChange={handleDeliveryOptionChange} 
          abTestVariant={null}
        />
      )}
      {showUpsellPopUp && Object.keys(finalAlternativeProducts).length === 0 && (
        <>
          {upsellVariant === 'A' && (
            <UpsellPopUp 
              handleDeliveryOptionChange={handleDeliveryOptionChange} 
              abTestVariant="A"
            />
          )}
          {upsellVariant === 'B' && (
            <UpsellPopUpV2 
              abTestVariant="B"
            />
          )}
          {upsellVariant !== 'A' && upsellVariant !== 'B' && (
            <UpsellPopUp 
              handleDeliveryOptionChange={handleDeliveryOptionChange}
              abTestVariant={null}
            />
          )}
        </>
      )}

      {/* Fast Review Upsell Popup */}
      <FastReviewUpsellPopUp 
        isVisible={showFastReviewUpsell}
        onClose={() => {
          setShowFastReviewUpsell(false);
          setIsExpressPrescriptionReview(false);
          isFastReviewUpsellShown.current = true;
        }}
      />

      {/* Express Delivery Upsell Popup */}
      {expressUpsellVariant && (
        <ExpressDeliveryUpsellPopup
          isVisible={showExpressDeliveryUpsell}
          variant={expressUpsellVariant}
          onApply={handleExpressUpsellApply}
          onContinue={handleExpressUpsellContinue}
          onClose={handleExpressUpsellClose}
          language={language}
        />
      )}

      {/* RX Premium Upsell Popup */}
      {showRxPremiumUpsellPopup && (
        <RxPremiumUpsellPopup
          variant={country === 'de' ? 'DE' : 'FR_CH'}
          onAccept={handleRxUpsellAccept}
          onDecline={handleRxUpsellDecline}
          onClose={handleRxUpsellClose}
        />
      )}

      {isFreeTreatmentCart ? (
        <div
          id="shipping-page-free-treatment-banner"
          className="sticky top-0 pin-below-app-bar z-10 mb-[20px] flex w-full items-center justify-center gap-2 rounded-[6px] py-2 px-3 text-center font-roboto text-[14px] font-semibold text-white"
          style={{ background: FREE_TREATMENT_BANNER_BACKGROUND }}
        >
          <img
            src={giftIcon}
            alt=""
            width={GIFT_ICON_SIZE_PX}
            height={GIFT_ICON_SIZE_PX}
          />
          <span>
            {translator.translate(language, "shipping", "ShippingPage/free_treatment_banner")}
          </span>
          {shouldShowBannerOldPrice ? (
            <span
              id="shipping-page-free-treatment-banner-old-price"
              className="rounded-[6px] px-2 py-0.5 font-roboto font-bold line-through"
              style={{ background: FREE_TREATMENT_BANNER_OLD_PRICE_BADGE_BACKGROUND }}
              translate="no"
            >
              {translator.getPrice(originalTreatmentFee, cartCurrency.locale, cartCurrency.rate)}
            </span>
          ) : null}
        </div>
      ) : null}

      {isCarePlusOrder ? (
        <ShippingV3CarePlus
          t={carePlusT}
          showFaq={showsCarePlusShippingFAQ(country)}
          addressForm={carePlusAddressForm}
          couponControl={carePlusCouponControl}
          cartSummary={carePlusCartSummary}
          costBreakdown={carePlusCostBreakdown}
          cta={carePlusCta}
        />
      ) : (
      <>
      {/* Page Title  */}
      <h1 id='shipping-page-title' className='text-center w-fit justify-self-center md:text-[32px] mb-[60px] text-[#0d2c54]'>
        {translator.translate(language, "shipping", "ShippingPage/main_title")}
      </h1>

      {/* Panels Container  */}
      <div id='shipping-page-panels-container' className='relative flex flex-col lg:flex-row h-full md:justify-center lg:gap-[50px]'>

        {/* Mobile Upsell Banner - hidden on desktop */}
        <div className="lg:hidden">
          {eligibleForUpsell && !wasUpgradedToPremium && <UpsellUpgradeBanner onUpgradeClick={() => setShowUpsellPopUp(true)} />}
        </div>


        {/* Right Panel - Cart View (appears first on mobile, second on desktop) */}
        <div id='shipping-page-right-panel' className='flex flex-col w-full lg:w-[375px] rounded-[6px] lg:sticky lg:top-[20px] pin-below-app-bar pin-offset-20 h-fit order-2 lg:order-2 mb-[50px] lg:mb-0'>          <span id='right-panel-title' className='font-semibold font-roboto text-[#98a0af] text-[13px] mb-[15px] block'>{translator.translate(language, "shipping", "layout/right_panel_title")}</span>

          {/* Fast Doctor Review – when self_pickup or only_prescription and express doctor is available */}
          {/* HL-12814: a Flowzz Only Prescription cart from an fda=1 link keeps the toggle too */}
          { isFastApprovalFlow && isCannabisOrder && (isSelfPickup || isOnlyPrescription) && (!isFlowzzFlow || isFlowzzFastApprovalOffer) && !isCannaleoFlow && !isFastApprovalInCart.current ? (
            <div className="mb-4">
              <FastDoctorReview
                enabled={isExpressPrescriptionReview}
                onToggleChange={async (enabled: boolean) => {
                  setIsExpressPrescriptionReview(enabled);
                  await updateCartAndDB({ is_express_prescription_review: enabled });
                  const couponCode = couponWidgetState.inputCode;
                  if (couponCode) {
                    handleApplyCoupon({ inputCode: couponCode });
                  }
                  if (enabled) {
                    setUpsellSaveAmount((upsellSaveAmount || 0) + (cart.fast_approval_fee || 5));
                  } else {
                    setUpsellSaveAmount((upsellSaveAmount || 0) - (cart.fast_approval_fee || 5));
                  }
                }}
                title={translator.translate(language, 'choose_treatment', 'shipping_and_service_selection/fast_doctor_review_title')}
                description={translator.translate(language, 'choose_treatment', 'shipping_and_service_selection/fast_doctor_review_description')}
                label={translator.translate(language, 'choose_treatment', 'default/label')}
                toggleId="fast-doctor-review-toggle-shipping"
              />
            </div>
          ) : null}

          {/* CartView */}

          {cart.flow  === Constants.ORDER_FLOWS.OTC_ONLY ?
          <OTCCartView shippingFee={expressDeliveryState?.isSelected ? cart.custom_shipping_fee || 0 : otcOnlyShippingFee}  isExpressShipping={expressDeliveryState?.isSelected} />
            : shouldShowPriceBreakdown(country, cart.products)
            ?
          <CartViewDE 
            productsGroupedByPharmacy={productsGroupedByPharmacy}
            hideSubscriptionPlans={isSubscriptionAlreadyPicked} 
            isExpressShipping={expressDeliveryState?.isSelected} 
            isCannabisCatalog={isCannabisCatalog}
            OTCAddonsTrigger={otcPopupVariant !== "C" && OTCAddonsTrigger}
            onExpandProducts={() => setUserClicks(prev => new Set(prev).add(CLICK_EXPAND_PRODUCTS))}
            onTooltipOpen={(tooltipId: string) => setOpenedTooltips(prev => new Set(prev).add(tooltipId))}
          />
          :
          <CartView 
            hideSubscriptionPlans={isSubscriptionAlreadyPicked} 
            isExpressShipping={expressDeliveryState?.isSelected}
            OTCAddonsTrigger={otcPopupVariant !== "C" && OTCAddonsTrigger}
          />
          }
          {(showCouponInput && !saleVoucherRequired) ? <CouponWidgetV2 /> : null}
          {/* Digital Cannabis ID Card widget  */}
          {
            digitalCannabisIDState.showWidget ?
              <DigitalCannabisIDWidget
                onTextChange={(text) => setDigitalCannabisIDState(current => ({ ...current, personalIDNumber: text, errorMsg: "" }))}
                onToggle={handleDigitalCannabisToggle}
                isToggleEnabled={digitalCannabisIDState.isToggleEnabled}
                isToggleLoading={digitalCannabisIDState.isToggleLoading}
                inputValue={digitalCannabisIDState.personalIDNumber}
                inputErrorMsg={digitalCannabisIDState.errorMsg}
                setRef={(ref) => setDigitalCannabisIDState((current) => ({ ...current, widgetRef: ref }))}
              />
              :
              null
          }

          {/* CouponWidget */}
          {saleVoucherRequired ?  <SaleVoucherWidget /> : null}

          {/*Cart View FAQ - Desktop only (price-breakdown countries, not CH cannabis; CH only for test-lab carts) */}
          {(shouldShowPriceBreakdown(country, cart.products) && !(country?.toUpperCase() === Constants.SWITZERLAND && isCannabisCatalog))
            || (country?.toUpperCase() === Constants.SWITZERLAND && !!testLabSampleType) ? (
            <div>
              <CartViewFAQ flow={cart.flow} sampleType={testLabSampleType} isCarePlus={isCarePlusOrder} isCannabis={isCannabisCatalog} />
            </div>
          ) : null}

        </div>

        {/* Left Panel - Delivery Options (appears second on mobile, first on desktop) */}
        <div id='shipping-page-left-panel-container' className='w-full lg:w-[540px] mb-[50px] md:mb-0 order-1 lg:order-1'>
          <span id='left-panel-title' className='font-semibold text-[#98a0af] font-roboto text-[13px] mb-[15px] block'>{translator.translate(language, "shipping", "layout/left_panel_title")}</span>
          <div id='shipping-page-left-panel' ref={leftPanelRef} className='flex flex-col h-fit w-full rounded-[6px] gap-y-4' >

            {/* A/B Test Variant B: Show Package Station first */}
            {isPackstationFirst && dhlPackstationPanel}

            {/* Personal Address Shipping Panel  */}
            <DeliveryOptionPanel
              code={PERSONAL_ADDRESS}
              title={
                cart.selected_service_option === "self_pickup" ? translator.translate(language, "shipping", "serviceOptions/pickup_from_pharmacy")
                  : translator.translate(language, "my_account", `SubscriptionOrders/addressInfoCard/personalAddress`)
              }
              isSelected={selectedOptionPanelCode === PERSONAL_ADDRESS}
              onPartnerPharmaciesOpen={() => setUserClicks(prev => new Set(prev).add(CLICK_PARTNER_PHARMACIES_POPUP))}
              onPharmacyDetailsExpand={() => setUserClicks(prev => new Set(prev).add(CLICK_PHARMACY_DETAILS_EXPAND))}
              hideOptionCards={categoryCatalogMention === "online-vd"}
              onSelect={() => setSelectedOptionPanelCode(PERSONAL_ADDRESS)}
              hideHeader={hidePackstation || Boolean(preSelectedExternalPharmacy) || Boolean(selfPickupPharmacySettings)} //Only in this flow UI changes for some reason... 
              isOtcOnlyFlow={cart.flow === Constants.ORDER_FLOWS.OTC_ONLY}
            >

              {regularAddressForDisplay && !useFreshAddressForm && (
                <DeliveryAddressCard
                  address={regularAddressForDisplay.address as string}
                  city={regularAddressForDisplay.city as string}
                  phone={regularAddressForDisplay.phone as string}
                  addressSubType={regularAddressForDisplay.address_sub_type as string}
                  label={translator.translate(language, "shipping", "layout/living_address") || "Delivery address"}
                  onClick={() => setShowAddressesModal(true)}
                />
              )}
              <DeliveryAddressForm
                key={formKey}
                showToggle={!hideToggleAddressAsBilling}
                defaultValues={deliveryAddressDefaultValues}
                isGoogleAPILoaded={isGoogleAPILoaded}
                isAddressCardMode={!!regularAddressForDisplay && !useFreshAddressForm}
                orangeToggle={isCarePlusOrder}
              />
            </DeliveryOptionPanel>
            {/* DHL Packstation - Control (Variant A) or when variant B is not active */}
            {!isPackstationFirst && dhlPackstationPanel}
          </div>
        </div>


      </div>

      {/* Sticky Submit button */}
      {isCannabisCatalog ? (
        cart.selected_service_option && identityCheckState?.showWidget ? (
          <StickySubmit
            submitButtonLoading={isSubmitButtonDisabled}
            formID={selectedFormID}
            isButtonDisabled={Boolean(cart.risk_groups?.some((group) => group.status !== 'clear'))}
            buttonPlaceholder={submitButtonPlaceholder}
            onSubmit={() => {
              handleContinueClick();
              if(isCannabisCatalog){
                // Track user click breakdown event
                MainTracker.track("custom", "user click breakdown", {
                  "page": "Shipping",
                  "Click on delivery options": false,
                  "Click on Medication tooltip": openedTooltips.has(TOOLTIP_MEDICATION),
                  "Click on Service Fee tooltip": openedTooltips.has(TOOLTIP_SERVICE_FEE),
                  "Click on Treatment Fee tooltip": openedTooltips.has(TOOLTIP_TREATMENT_FEE),
                  "Click expand product (show/hide)": userClicks.has(CLICK_EXPAND_PRODUCTS),
                  "Click on Partner Pharmacies pop-up": userClicks.has(CLICK_PARTNER_PHARMACIES_POPUP),
                  "Click on pharmacy details (expand)": userClicks.has(CLICK_PHARMACY_DETAILS_EXPAND),
                  "Click on terms": userClicks.has(CLICK_TERMS_LINK),
                  "Click on doctor details tooltip": false,
                  "Click on product pharmacy tooltip": false
                });
              }

            }} 
          >
            <TogglePrecaution
              isToggleEnabled={identityCheckState?.isPrecautionToggleEnabled}
              precautionLevel={identityCheckState?.precautionLevel}
              updateToggle={() =>
                setIdentityCheckState(current => ({
                  ...current,
                  precautionLevel: "info",
                  isPrecautionToggleEnabled: !current.isPrecautionToggleEnabled
                }))
              }
              isCannabisCatalog={isCannabisCatalog}
              isOnlyPrescription={cart.only_prescription}
              onTermsLinkClick={() => setUserClicks(prev => new Set(prev).add(CLICK_TERMS_LINK))}
            />
          </StickySubmit>
        ) : (
          <StickySubmit
            submitButtonLoading={isSubmitButtonDisabled}
            formID={selectedFormID}
            isButtonDisabled={Boolean(cart.risk_groups?.some((group) => group.status !== 'clear'))}
            buttonPlaceholder={submitButtonPlaceholder}
            onSubmit={handleContinueClick}
          />
        )
      ) : (
        <StickySubmit
          submitButtonLoading={isSubmitButtonDisabled}
          formID={selectedFormID}
          isButtonDisabled={!cart.selected_service_option || Boolean(cart.risk_groups?.some((group) => group.status !== 'clear'))}
          buttonBackgroundColor={isCarePlusOrder ? "linear-gradient(90deg, #f59200 0%, #ffbb29 100%)" : ""}
          buttonPlaceholder={submitButtonPlaceholder}
          onSubmit={handleContinueClick}
        >
        <>
            {
              !cart.selected_service_option && (
                <div className="text-red-500 text-sm font-medium">
                  {translator.translate(language, "shipping", "validation/select_delivery_option_message")}
                </div>
              )
            }
            {identityCheckState?.showWidget ?
              <TogglePrecaution
                isToggleEnabled={identityCheckState?.isPrecautionToggleEnabled}
                precautionLevel={identityCheckState?.precautionLevel}
                updateToggle={() =>
                  setIdentityCheckState(current => ({
                    ...current,
                    precautionLevel: "info",
                    isPrecautionToggleEnabled: !current.isPrecautionToggleEnabled
                  }))
                }
                isCannabisCatalog={isCannabisCatalog}
                isOnlyPrescription={cart.only_prescription}
                onTermsLinkClick={() => setUserClicks(prev => new Set(prev).add(CLICK_TERMS_LINK))}
                orange={isCarePlusOrder}
              />
              :
              null
            }
          </>
        </StickySubmit>
      )}
      </>
      )}
    </>

  )
}

export default ShippingV2;
